import React, { useState } from "react";

const TagInput = ({ tags, setAnimities, placeholder = "Add a tag..." }) => {
  const [inputValue, setInputValue] = useState("");

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && inputValue.trim() !== "") {
      e.preventDefault();
      if (tags && tags.length>0 && !tags.includes(inputValue.trim())) {
        setAnimities([...tags, inputValue.trim()]);
      } else {
        setAnimities([inputValue.trim()]);
      }
      setInputValue("");
    }
  };

  const removeTag = (index) => {
    setAnimities(tags.filter((_, i) => i !== index));
  };

  return (
    <div>
    <div className="tag-input-container">
      {tags && tags.length > 0 ? tags.map((tag, index) => (
        <div key={index} className="tag">
          {tag}
          <span className="remove-tag" onClick={() => removeTag(index)}>✕</span>
        </div>
      )) : ''}
      
    </div>
    <div className="form-group">
        <input
            type="text"
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            onKeyDown={handleKeyDown}
            placeholder={placeholder} 
            className="form-control"
        />
    </div>
    
    </div>
  );
};

export default TagInput;